import styled from 'styled-components'

import { white, bordergray, red, gold } from '../../styles/colors'
import { minmedia, maxmedia } from '../../styles/media-queries'

export const Description = styled.div`
  font-size: 18px;
  font-weight: 300;
  text-align: left;
  line-height: 1.5;
  max-width: calc(100% - 2rem);
  margin: 0.5rem auto;
  margin-top: 2rem;
  ${minmedia.large`
    max-width: 1000px;
    font-size: 20px;
    text-align: center;
  `};
  strong {
    font-weight: 500;
    color: ${red};
  }
`

export const ServicePackage = styled.div`
  width: 100%;
  background: ${white};
  padding: 1.5rem 2rem;
  border: 1px solid ${bordergray};
  border-radius: 0.25rem;
  margin: 0 auto;
  margin-bottom: 2rem;
  max-width: calc(100% - 2rem);
  
  ${minmedia.large`
    width: calc(100% / 3 - 1rem);
    margin: 0;
    order: auto;
  `};
  &.active {
    border: 2px solid ${red};
    ${maxmedia.large`
    order: -1;
    `};
  }
  h3 {
    font-size: 26px;
    font-weight: 400;
    border-bottom: 1px solid ${bordergray};
    padding-bottom: 1.5rem;
    margin-bottom: 1.5rem;
    ${maxmedia.large`
      font-size: 20px;
    `};
  }
  ul {
    list-style: none;
  }
  li {
    margin: 0.5rem 0;
    padding-left: 1.5rem;
    position: relative;
    ${maxmedia.large`
      font-size: 16px;
    `};
    &::before {
      content: '';
      background: ${gold};
      width: 0.35rem;
      height: 0.35rem;
      border-radius: 100%;
      display: inline-block;
      position: absolute;
      left: 0;
      top: 0.5rem;
    }
    font-size: 18px;
    line-height: 1.4;
  }
`



// WEBPACK FOOTER //
// ./src/views/Packages/styles.js